import { FEATURES } from '@constants/Text'

export function canShowOrUpsell(access, ...flags) {
  if (!access) return false
  if (flags.some((f) => !!access[f])) return true
  return !access[FEATURES.OCULTAR_CROSS_SELL]
}

export function hasNoFeatureAccess(access, ...flags) {
  if (!access) return true
  return !flags.some((f) => !!access[f])
}
